export default __webpack_public_path__ + "static/media/C6.4e06e40e.png";